// App.js
import React, { useState, useEffect } from 'react';
import '../App.scss'

import IconButton from '@mui/material/IconButton';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

import Card from '@mui/material/Card';

function Vowels() {
  const hangulData = [
    {
      character: '아',
      pronunciation: 'a',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/a.mp3',
    },
    {
      character: '이',
      pronunciation: 'i',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/i.mp3',
    },
    {
      character: '우',
      pronunciation: 'u',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/u.mp3',
    },
    {
      character: '으',
      pronunciation: 'eu',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/eu.mp3',
    },
    {
      character: '에',
      pronunciation: 'e',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/e.mp3',
    },
    {
      character: '애',
      pronunciation: 'ae',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/ae.mp3',
    },
    {
      character: '오',
      pronunciation: 'o',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/o.mp3',
    },
    {
      character: '어',
      pronunciation: 'eo',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/eo.mp3',
    },
    {
      character: '야',
      pronunciation: 'ya',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/ya.mp3',
    },
    {
      character: '유',
      pronunciation: 'yu',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/yu.mp3',
    },
    {
      character: '요',
      pronunciation: 'yo',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/yo.mp3',
    },
    {
      character: '여',
      pronunciation: 'yeo',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/yeo.mp3',
    },
    {
      character: '예',
      pronunciation: 'ye',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/ye.mp3',
    },
    {
      character: '얘',
      pronunciation: 'yae',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/yae.mp3',
    },
    {
      character: '와',
      pronunciation: 'wa',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/wa.mp3',
    },
    {
      character: '위',
      pronunciation: 'wi',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/wi.mp3',
    },
    {
      character: '의',
      pronunciation: 'ui',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/ui.mp3',
    },
    {
      character: '웨',
      pronunciation: 'we',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/we.mp3',
    },
    {
      character: '외',
      pronunciation: 'oe',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/oe.mp3',
    },
    {
      character: '왜',
      pronunciation: 'wae',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/wae.mp3',
    },
    {
      character: '워',
      pronunciation: 'wo',
      audioUrl: 'https://hangulmatch.s3.ap-northeast-1.amazonaws.com/audios/vowels/wo.mp3',
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [audio, setAudio] = useState(new Audio(hangulData[currentIndex].audioUrl));

  useEffect(() => {
    setAudio(new Audio(hangulData[currentIndex].audioUrl));
  }, [currentIndex]);

  const playSound = () => {
    audio.play();
    // 1秒後に次のインデックスに移動します
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % hangulData.length);
    }, 500); // 1000ミリ秒 = 1秒
  };

  const currentHangul = hangulData[currentIndex];

  return (
    <>
      <div className="vowels">
        <Card className="vowel_card" variant="outlined">
          <div className="vowel_character">{currentHangul.character}</div>
          <div className="vowel_pronunciation"><b><small>[ </small>{currentHangul.pronunciation}<small> ]</small></b></div>
          <IconButton className="vowel_button" onClick={playSound} aria-label="play">
            <PlayCircleFilledIcon />
          </IconButton>
          <p>{currentIndex + 1}/19</p>
        </Card>
      </div>
    </>
  );
}

export default Vowels;

